// extracted by mini-css-extract-plugin
export default {"skillsCommunityStatus":"style_skillsCommunityStatus__Q4toT","skillsItem":"style_skillsItem__14kyh","tags":"style_tags__cdj-U","heading":"style_heading__xB8ir"};